export default __webpack_public_path__ + "static/media/van.4fdd1ef6.png";